import { ICommonAPIErrorResponse } from '@/services/common/api';
import { ITechAnalytics } from './types';

async function fetchFromApi<T>(url: string): Promise<T | []> {
    try {
        const res = await fetch(url);

        if (!res.ok) {
            console.error(`[technicalAnalysis] Failed to fetch ${url}:`, res.statusText);
            return [];
        }

        const data = await res.json();

        if ((data as ICommonAPIErrorResponse)?.isFailed) {
            return [];
        }

        return data as T;
    } catch (error) {
        console.error(`[technicalAnalysis] Error fetching ${url}:`, error);
        return [];
    }
}

export const technicalAnalysis = {
    getAllTickers: async (): Promise<ITechAnalytics | []> => {
        return await fetchFromApi<ITechAnalytics>(`/api/technical-analysis/tickers`);
    },

    getTechnicalAnalysisData: async ({
        ticker,
        timeFrame,
    }: {
        ticker: string;
        timeFrame: string;
    }): Promise<ITechAnalytics | []> => {
        return await fetchFromApi<ITechAnalytics>(
            `/api/technical-analysis/${ticker}/${timeFrame}`
        );
    },
};
